import SuggestionsField from '../../SuggestionsField';
import withAutocomplete from '../../Containers/withAutocomplete';

const LocationSuggestion = withAutocomplete(
  SuggestionsField,
  '/api/hjv/suggestlocation',
  (hits) => {
    if ((hits && hits.Items) || !!hits?.length) {
      return [
        { Name: 'Nära mig', IsNearBy: true },
        ...(hits?.Items ? hits?.Items : hits),
      ];
    }

    return [{ Name: 'Nära mig', IsNearBy: true }];
  },
  (selectedObject) => (selectedObject ? selectedObject.Name : ''),
  (_, value) => value,
  1,
  // queryparamstring
  (props) => `&st=${props.sessiontoken}`,
  // min string length before we request the api
  () => 3
);

export default LocationSuggestion;

export const getNearby = () => ({
  text: 'Nära mig',
  className: 'nearby',
  IsNearBy: true,
  excludeAutoselect: true,
});

export const getCountry = (country) => ({
  text: country,
  Value: '',
  IsNearBy: false,
});

export const getRegion = (r) => ({
  text: r.Name,
  Value: r.Value,
  Type: r.Type,
  IsNearBy: false,
});

export function getDefaultLocations(region, country) {
  let items = [getNearby(), getCountry(country)];
  return !region ? items : [...items, getRegion(region)];
}
